import axios from "axios";
import { config } from "../config";

export class DocumentsService {
  /*********** List ***********/
  public list = async (): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.get(serverUrl + "documents");
      return response.data;
    } catch (error) {
      return { message: "error" };
    }
  };

  /*********** Create ***********/
  public add = async (data: any): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.post(serverUrl + "documents", data);
      return response.data;
    } catch (error) {
      return { message: "error" };
    }
  };

  /*********** DELETE ***********/
  public delete = async (id: number): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.delete(serverUrl + `documents/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      return { message: "error" };
    }
  };
}
